import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { Show } from '@side/pantry';
import { DATE_RANGE_OPTIONS } from '../types';
import { getDateFilterChipLabel } from './DatesFilter.helpers';
import { useFactsAndFiguresContext } from './FactsAndFiguresContext';

export function TransactionStatusSnapshotChips() {
  const {
    agents,
    endDate,
    startDate,
    dateRange,
    filtersCount,
    onChangeDateRange,
    onChangeEndDate,
    onChangeStartDate,
    onDeleteAgent,
  } = useFactsAndFiguresContext();

  const dateFilterChipLabel = getDateFilterChipLabel({
    dateRange,
    endDate,
    startDate,
  });

  return (
    <Show data-test-id="TransactionStatusSnapshotChips" when={filtersCount}>
      <Stack
        sx={{
          columnGap: 1,
          flexDirection: 'row',
          flexWrap: 'wrap',
          maxWidth: '100%',
          mt: { xs: 2, md: 1 },
          mx: { xs: 2, md: 0 },
          rowGap: 1.25,
        }}
      >
        {agents.map((agent) => (
          <Chip
            key={agent.value}
            label={agent.label}
            onDelete={() => {
              onDeleteAgent(agent);
            }}
            size="medium"
            variant="outlined"
          />
        ))}

        <Show when={dateFilterChipLabel}>
          <Chip
            color="default"
            variant="outlined"
            onDelete={() => {
              onChangeDateRange(DATE_RANGE_OPTIONS.DEFAULT);
              onChangeEndDate(null);
              onChangeStartDate(null);
            }}
            label={dateFilterChipLabel}
          />
        </Show>
      </Stack>
    </Show>
  );
}
